<template lang="pug">
.c-article-section
  section-banner {{ article ? article.title : title }}
  .section
    .container
      article-content(v-if="article"
        v-bind="article"
        :hideTitle="true")
</template>

<script>
import SectionBanner from "@/components/SectionBanner.vue";
import ArticleContent from "@/components/ArticleContent.vue";

export default {
  name: "ArticleSection",
  components: {
    SectionBanner,
    ArticleContent
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    article: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style module lang="sass">
.sub
  div
    display: inline-block
</style>
